import styled from 'styled-components';

const Text = styled.span`
  ${({ theme }) => theme.fontFamily.secondaryFont.smallRegular}
  color: ${({ theme }) => theme.commons.global.textPrimary};
  margin-right: 8px;
`;

export default Text;
